/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { AdminGetOrgsOptions, AdminGetOrgsResponses } from '../../models/AdminGetOrgs'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @summary List Orgs
 * {@link /admin/orgs}
 */
export function adminGetOrgs<ThrowOnError extends boolean = true>(options: Options<AdminGetOrgsOptions, ThrowOnError> = {}): Promise<UnwrappedResult<AdminGetOrgsResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'GET', url: '/admin/orgs', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<AdminGetOrgsResponses, ThrowOnError>>
}
